import { createContext, useReducer } from "react";
import { ConfigReducer } from "./ConfigReducer";



const configInitialState = {
    theme: 'dark',
    language: 'es',
    timeLinePlanning: {
        dayWidth: 10,
        showDays: false,
        showWeeks: true,
        showMonths: true,
        dividerPosition: 300,
        sortBy: 'endTime',
        sortDirection: 'asc',
        showOptions: false,
    }
};


export const ConfigContext = createContext({});


export const ConfigProvider = ({children}) => { 
 
    const [config, dispatch] = useReducer(ConfigReducer, configInitialState, );

    const changeTheme = (theme) => {
        dispatch({type: 'changeTheme', payload: theme});
    }

    const changeLanguage = (language) => {
        dispatch({type: 'changeLanguage', payload: language});
    }

    const setConfig = (config) => {
        dispatch({type: 'setConfig', payload: config});
    }
    const setTimeLinePlanning = (config) => {
        dispatch({type: 'timeLinePlanning', payload: config});
    }

    return (
        <ConfigContext.Provider value={{ 
            config,
            changeTheme,
            changeLanguage,
            setConfig,
            setTimeLinePlanning
        }}>
            {children}
        </ConfigContext.Provider>
        );
};